import { Help } from '@ansarada/glyphs/shared/status/Help';
import { Box, Stack, Typography, TypographyProps } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import TranslationService from 'app/common/services/translation';

const ANSARADA_STATIC_LOGO =
  'https://static.ansarada.com/logos/0.3.0/ansarada-logomark-white.svg';
const ANSARADA_PAGE_URL = 'https://www.ansarada.com';
const ANSARADA_HELP_PAGE_URL =
  'https://www.ansarada.com/features/secure-file-share?utm_medium=product&utm_source=sfs&utm_campaign=fy23_c_pql_secure_file_sharing';
const ANSARADA_ADDRESS_URL = 'www.ansarada.com';

const BACKGROUND_COLOR = '#1e272e';

const Text = (props: TypographyProps) => (
  <Typography
    component="span"
    sx={(theme) => ({
      fontSize: theme.typography.subtitle1,
      fontWeight: theme.typography.fontWeightRegular,
      marginLeft: 3,
      lineHeight: 1.5,
      color: theme.palette.common.white,
    })}
    {...props}
  />
);

const SecureSharingHeader = () => {
  return (
    <AppBar
      enableColorOnDark
      position="static"
      sx={{
        backgroundColor: BACKGROUND_COLOR,
        padding: '12px 15px 12px 24px',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <Box
            component="a"
            href={ANSARADA_PAGE_URL}
            height="20px"
            sx={{
              textDecoration: 'none',
              display: 'inline-flex',
              alignItems: 'center',
            }}
          >
            <img
              data-test-id="ansarada-logo"
              alt="Ansarada"
              src={ANSARADA_STATIC_LOGO}
            />

            <Text>{TranslationService.get('SecureShare_Capitalize')}</Text>
          </Box>
        </Stack>

        <Box
          component="a"
          target="_blank"
          href={ANSARADA_HELP_PAGE_URL}
          sx={{
            textDecoration: 'none',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <Help sx={{ color: 'white' }} />
        </Box>

        <Box
          component="a"
          href={ANSARADA_PAGE_URL}
          sx={(theme) => ({
            textDecoration: 'none',
            color: theme.palette.common.white,
          })}
        >
          <Text>{ANSARADA_ADDRESS_URL}</Text>
        </Box>
      </Stack>
    </AppBar>
  );
};

export default SecureSharingHeader;
